<app-page-heading [heading]="heading"
                  [hasBackButton]="true"
                  [backPageName]="backPageName"
                  [tabName]="'cases'">
</app-page-heading>

<app-banner *ngIf="!isAuthorised" [bannerText]="bannerText"></app-banner>


<!---------------------------->
<!-- Stepper:-->
<!---------------------------->

<div class="stepper-container">
  <mat-horizontal-stepper #stepper [linear]="true">
    
    <!---------------------------->
    <!-- STEP: Association:-->
    <!---------------------------->
    
    <mat-step #associationMatStep [completed]="associationFormGroup.valid">
      <ng-template matStepLabel>Association</ng-template>
      <app-case-association-step #associationStep
                                 [type]="caseType.Medical"
                                 [data]="caseHospitalDTO"
                                 [formGroup]="associationFormGroup"
                                 [isEditMode]="isEditMode"
                                 (personId)="handleCommunicationNumberValue($event)"
                                 (updateForm)="onUpdateStepForm($event, formGroupName.ASSOCIATION_FORM_GROUP)"
                                 (updateHeading)="onUpdateHeadingChanged($event)"
                                 (updateIcdCategory)="onUpdateICDCategoryChangedInAssociationStep($event)">
      </app-case-association-step>
    </mat-step>
    
    <!---------------------------->
    <!-- STEP: Details -->
    <!---------------------------->
    
    <mat-step #detailsMatStep [completed]="detailsFormGroup.valid">
      <ng-template matStepLabel>Detail</ng-template>
      <app-case-details-step #detailsStep
                             [data]="caseHospitalDTO"
                             [formGroup]="detailsFormGroup"
                             [isEditMode]="isEditMode"
                             [processingClassSubtype]="processingClassSubtype"
                             (updateForm)="onUpdateStepForm($event, formGroupName.DETAILS_FORM_GROUP)">
      </app-case-details-step>
    </mat-step>
    
    <!---------------------------->
    <!-- STEP: Admission Reason-->
    <!-- Form BOTH conditions should met in order to navigate to next step -->
    <!---------------------------->
    
    <mat-step #admissionMatStep [completed]="admissionFormGroup.valid && isAdmissionFormValid">
      <ng-template matStepLabel>{{getLabelByCaseMedicalSubType(processingClassSubtype)}}</ng-template>
      <app-case-admission-step #admissionStep
                               [data]="caseHospitalDTO"
                               [formGroup]="admissionFormGroup"
                               [isEditMode]="isEditMode"
                               [icdCategoryFromAssociationStep]="icdCategoryInAssociationStep"
                               (isValid)="isAdmissionFormValid = $event"
                               [processingClassSubtype]="processingClassSubtype"
                               (updateForm)="onUpdateStepForm($event, formGroupName.ADMISSION_FORM_GROUP)">
      </app-case-admission-step>
    </mat-step>
    
    
    <!---------------------------->
    <!-- STEP: Documentation -->
    <!--
     This step is "OPTIONAL" step therefor not needed to catch (updateForm) from child
     to prevent navigating to next step without uploading any document. It is basically
     extra info provided to support "CASE" for any further proof/clarifications
    -->
    <!---------------------------->
    
    <mat-step #documentationMatStep [completed]="documentationFormGroup.valid">
      <ng-template matStepLabel>Documentation</ng-template>
      
      <app-case-documentation-step #documentationStep
                                   [caseHospitalId]=caseHospitalDTO?.caseHospitalId
                                   [data]="caseHospitalDTO"
                                   [formGroup]="documentationFormGroup"
                                   [isEditMode]="isEditMode"
                                   (uploadDocument)="handleAddNewDocumentWithoutCaseSave($event)"
                                   (deleteDocument)="handleDeleteNewDocumentWithoutCaseSave($event)">
      </app-case-documentation-step>
    </mat-step>
    
    
    <!---------------------------->
    <!-- STEP: Providers -->
    <!-- Form BOTH conditions should met: At least 1 provider should exist in order to navigate to next step  -->
    <!---------------------------->
    
    <mat-step #providersMatStep [completed]="providersFormGroup.valid && isProvidersFormValid">
      <ng-template matStepLabel>Providers</ng-template>
      
      <app-case-providers-step #providersStep
                               [data]="caseHospitalDTO"
                               [formGroup]="providersFormGroup"
                               [isEditMode]="isEditMode"
                               (isValid)="isProvidersFormValid = $event"></app-case-providers-step>
    </mat-step>
    
    
    <!---------------------------->
    <!-- STEP: Transaction:-->
    <!---------------------------->
    
    <mat-step #transactionMatStep *ngIf="isEditMode" [completed]="transactionFormGroup.valid">
      <ng-template matStepLabel>Transactions</ng-template>
      <app-case-transaction-step #transactionStep
                                 [data]="caseHospitalDTO"
                                 [formGroup]="transactionFormGroup"
                                 [isEditMode]="isEditMode"
                                 (updateForm)="onUpdateStepForm($event, formGroupName.TRANSACTION_FORM_GROUP)">
      </app-case-transaction-step>
    </mat-step>
    
    
    <!---------------------------->
    <!-- STEP: Utilisation:-->
    <!---------------------------->
    <mat-step #utilisationMatStep *ngIf="isEditMode" [completed]="utilisationFormGroup.valid">
      <ng-template matStepLabel>Utilisation</ng-template>
      <app-case-utilisaton-step #utilisationStep
                                [data]="caseHospitalDTO"
                                [formGroup]="utilisationFormGroup"
                                [isEditMode]="isEditMode"
                                (updateForm)="onUpdateStepForm($event, formGroupName.UTILISATION_FORM_GROUP)"></app-case-utilisaton-step>
    </mat-step>
    
    
    <!---------------------------->
    <!-- STEP: Payments:-->
    <!---------------------------->
    
    
    <ng-container *ngIf="processingClassSubtype !== processingClassSubTypeEnum.Pharmacy">
      <mat-step *ngIf="isEditMode" [completed]="paymentFormGroup.valid"
                #paymentMatStep>
        <ng-template matStepLabel>Payments</ng-template>
        <app-case-payments-step #paymentStep>
          <app-payments [paymentsByCaseId]="caseId"></app-payments>
        </app-case-payments-step>
      </mat-step>
    </ng-container>
    
    <!---------------------------->
    <!-- STEP: Issues:-->
    <!---------------------------->
    
    <mat-step #issuesMatStep [completed]="issueTicketFormGroup.valid">
      <ng-template matStepLabel>Issues</ng-template>
      <app-case-issues-step #issueStep
                            [type]="caseType.Medical"
                            [caseId]="caseId"
                            [data]="caseHospitalDTO"
                            [formGroup]="issueTicketFormGroup"
                            [isEditMode]="isEditMode"
                            (updateForm)="onUpdateStepForm($event, formGroupName.ISSUE_TICKET_FORM_GROUP)">
      </app-case-issues-step>
    </mat-step>
    
    <!---------------------------->
    <!-- STEP: Status:-->
    <!---------------------------->
    
    <mat-step #statusMatStep [completed]="issueTicketFormGroup.valid">
      <ng-template matStepLabel>Status</ng-template>
      <app-case-status-step #statusStep
                            [type]="caseType.Medical"
                            [data]="caseHospitalDTO"
                            [formGroup]="statusFormGroup"
                            [isEditMode]="isEditMode"
                            (updateForm)="onUpdateStepForm($event, formGroupName.STATUS_FORM_GROUP)"
                            (onSave)="saveCaseHospitalDTO()"
                            (onDischargeType)="saveCaseHospitalDTOAndCreateLinkedCase($event)">
      </app-case-status-step>
    </mat-step>
  
  </mat-horizontal-stepper>
</div>
